import { Inject } from '@odinjs/odin';

import { ProviderAccreditationPendenciesService } from '@philips-emr/hpms-provider-commons';
import providerContext from '@philips-emr/hpms-provider-commons/lib/context/provider-context';
import { HPMSOnAfterSubmitAmountProfessionalsCard } from '@philips-emr/hpms-provider-components';
import { FetchAPI, PanelAPI, ToastNotificationAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnMount } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { isEmptyArrayOrObject } from '@philips-emr/tws-utils';

import { AccreditationAmountProfessionalsAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

import { AccreditationSteps } from './accreditation-update-controller';

@Controller ({ fragment: FragmentNames.ACCREDITATION_AMOUNT_PROFESSIONALS })
class AccreditationAmountProfessionalsController extends BaseController {

  @Inject(Aliases.FETCH_AMOUNT_PROFESSIONALS)
  private fetchListProfessionals: FetchAPI;
  @Inject(Aliases.PANEL_PENDENCIES)
  private panelPendencies: PanelAPI;
  @Inject(Aliases.TOAST_NOTIFICATION)
  private toastNotification: ToastNotificationAPI;

  @OnMount(Aliases.LAYOUT_AMOUNT_PROFESSIONALS)
  onMountLayoutAmountProfessionals(): void {
    const { nrSeqAccreditation } = this.historyService.getCurrentRouteParams();
    const nrSeqProvider = providerContext.getSelectedProvider().nrSeqProvider;
    this.context.set({ nrSeqAccreditation, nrSeqProvider });
    this.fetchListProfessionals.forceFetch();
  }

  @OnMount(Aliases.FETCH_PENDENCIES)
  onMountFetchPendencies(event: MountEvent): void {
    ProviderAccreditationPendenciesService.fetchCardPendencies(event, AccreditationSteps.AMOUNT_PROFESSIONALS);
  }

  @OnAfterFetch(Aliases.FETCH_PENDENCIES)
  onAfterFetchPendencies(event: FetchEvent): void {
    if(isEmptyArrayOrObject(event.data)){
      this.panelPendencies.setVisible(false);
    } else {
      ProviderAccreditationPendenciesService.setMessageToastPendency(this.toastNotification, event);
    }
  }

  @HPMSOnAfterSubmitAmountProfessionalsCard(Aliases.HPMS_AMOUNT_PROFESSIONALS_CARD)
  hPMSOnAfterSubmitAmountProfessionals(): void {
    this.fetchListProfessionals.forceFetch();
  }
}

export {
  AccreditationAmountProfessionalsController,
};
